import React from 'react';
import styled from 'styled-components';

const JustFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export default JustFlex;
